const testimonials = [
  {
    name: 'AC Z',
    role: 'Pinneberg',
    initials: 'AZ',
    color: '#1A5C3D',
    featured: true,
    text: 'Ich geh seit ca einem Jahr 1 Mal in diese Studio. Da ich eine neurologische Vorerkrankung mit leichten Spastiken habe, war selbst mein Neurologe unsicher, ob ich das gut vertrage. Und was soll ich sagen – ich vertrage es nicht nur, sondern es hat mich einen großen Schritt weitergebracht. Mein Gleichgewichtssinn hat sich stark verbessert. Jonathan, Inhaber, geht perfekt und mit kreativen Übungen auf meine Defizite ein. Ich fühle mich sehr wohl und kann es Menschen mit Einschränkungen sehr empfehlen!',
    result: 'Gleichgewicht verbessert',
    weeks: '1 Jahr',
  },
  {
    name: 'Peter Petersen',
    role: 'Pinneberg',
    initials: 'PP',
    color: '#2D6A5A',
    featured: false,
    text: 'Besonders überzeugt hat mich die Kombination aus Professionalität und der familiären Atmosphäre. Die Trainer nehmen sich wirklich Zeit, gehen auf individuelle Ziele ein und sorgen dafür, dass man beim Muskelaufbau immer die richtige Haltung bewahrt. Das Studio ist modern, extrem sauber und die 20 Minuten pro Woche sind perfekt in meinen Alltag integrierbar. 5 Sterne!',
    result: 'Rückenschmerzen weg',
    weeks: '1 Monat',
  },
  {
    name: 'Markus Sandmeier',
    role: 'Pinneberg',
    initials: 'MS',
    color: '#3D5C45',
    featured: false,
    text: 'Das EMS Training ist für mich ein absoluter Gamechanger: In nur 20 Minuten pro Woche habe ich bereits sichtbare Erfolge bei der Körperstraffung und Fettverbrennung erzielt. Die Trainer stellen das Programm genau so ein, dass der Stoffwechsel maximal angekurbelt wird. Absolute Empfehlung für den Muskelaufbau und die Figur!',
    result: 'Körperstraffung',
    weeks: '1 Monat',
  },
  {
    name: 'Nicole',
    role: 'Pinneberg',
    initials: 'NI',
    color: '#4A6A52',
    featured: false,
    text: 'Sehr gute und vor allem ganzheitliche Beratung! Ich kam wegen Gelenkbeschwerden in Händen und Knien und mir geht es inzwischen schon sehr viel besser. Keine generelle Abfertigung, wie ich das aus anderen Studios kannte. Klein, fein und persönlich. Ich bin froh, mein Studio gefunden zu haben.',
    result: 'Gelenkbeschwerden besser',
    weeks: '4 Monate',
  },
  {
    name: 'Hannah Lück',
    role: 'Pinneberg',
    initials: 'HL',
    color: '#2A5C48',
    featured: false,
    text: 'Ich bin seit ca 4 Monaten, einmal die Woche zum Training da und bin absolut zufrieden und glücklich. Ich fühle mich dort gut aufgehoben und beraten. Kompetent, aufmerksam und freundlich kümmert sich das Team dort um seine Kunden und ich gehe immer gerne hin – obwohl ich sonst ein ziemlicher Sportmuffel bin.',
    result: 'Regelmäßig dabei',
    weeks: '4 Monate',
  },
];

export default function TestimonialsSection() {
  const featured = testimonials.find((t) => t.featured);
  const rest = testimonials.filter((t) => !t.featured);

  return (
    <section id="testimonials" className="py-24 md:py-32 overflow-hidden" style={{ backgroundColor: '#0A1510' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-5 mb-14">
          <div>
            <span
              className="text-xs font-medium tracking-[0.2em] uppercase"
              style={{ fontFamily: 'Inter, sans-serif', color: '#5DC48E' }}
            >
              Stimmen aus Pinneberg
            </span>
            <h2
              className="text-3xl md:text-5xl font-bold text-white mt-4 leading-[1.1]"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              Was wirklich passiert,<br />
              <span style={{ color: 'rgba(255,255,255,0.22)' }}>wenn man anfängt.</span>
            </h2>
          </div>
          <div
            className="flex items-center gap-3 border rounded-2xl px-5 py-3.5 flex-shrink-0 self-start md:self-auto"
            style={{ borderColor: 'rgba(93,196,142,0.18)' }}
          >
            <div className="flex gap-0.5">
              {[1,2,3,4,5].map((s) => (
                <div key={s} className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-star-fill text-yellow-400 text-xs"></i>
                </div>
              ))}
            </div>
            <div>
              <div className="text-white font-semibold text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>5,0 von 5</div>
              <div className="text-xs" style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.3)' }}>Google · 20 Bewertungen</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 items-start">
          {featured && (
            <div
              className="lg:col-span-3 rounded-3xl p-8 md:p-10 flex flex-col border"
              style={{ backgroundColor: '#111A15', borderColor: 'rgba(93,196,142,0.1)' }}
            >
              <div className="flex gap-1 mb-7">
                {[1,2,3,4,5].map((s) => (
                  <div key={s} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-yellow-400 text-sm"></i>
                  </div>
                ))}
              </div>
              <p
                className="text-xl md:text-[23px] leading-relaxed flex-1"
                style={{ fontFamily: 'Cormorant Garamond, serif', color: 'rgba(255,255,255,0.86)', fontStyle: 'italic' }}
              >
                &ldquo;{featured.text}&rdquo;
              </p>
              <div
                className="flex items-center justify-between mt-9 pt-6 border-t"
                style={{ borderColor: 'rgba(255,255,255,0.07)' }}
              >
                <div className="flex items-center gap-3">
                  <div
                    className="w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-semibold flex-shrink-0"
                    style={{ backgroundColor: featured.color, fontFamily: 'Inter, sans-serif' }}
                  >
                    {featured.initials}
                  </div>
                  <div>
                    <div className="text-white font-medium text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>{featured.name}</div>
                    <div className="text-xs mt-0.5" style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.3)' }}>{featured.role}</div>
                  </div>
                </div>
                <div className="text-right ml-4" style={{ maxWidth: '130px' }}>
                  <div
                    className="text-xs font-medium px-3 py-1 rounded-full break-words"
                    style={{ fontFamily: 'Inter, sans-serif', color: '#5DC48E', backgroundColor: 'rgba(93,196,142,0.1)', lineHeight: '1.4' }}
                  >
                    {featured.result}
                  </div>
                  <div className="text-xs mt-1.5" style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.2)' }}>
                    nach {featured.weeks}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-3">
            {rest.map((t, i) => (
              <div
                key={i}
                className="rounded-2xl p-6 flex flex-col gap-4 border"
                style={{ backgroundColor: '#111A15', borderColor: 'rgba(93,196,142,0.08)' }}
              >
                <div className="flex gap-0.5">
                  {[1,2,3,4,5].map((s) => (
                    <div key={s} className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-yellow-400 text-xs"></i>
                    </div>
                  ))}
                </div>
                <p
                  className="text-sm leading-relaxed flex-1"
                  style={{ fontFamily: 'Inter, sans-serif', fontWeight: 300, color: 'rgba(255,255,255,0.5)' }}
                >
                  &ldquo;{t.text}&rdquo;
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2.5">
                    <div
                      className="w-8 h-8 rounded-full flex items-center justify-center text-white text-xs font-semibold flex-shrink-0"
                      style={{ backgroundColor: t.color, fontFamily: 'Inter, sans-serif' }}
                    >
                      {t.initials}
                    </div>
                    <div>
                      <div className="text-white text-xs font-medium" style={{ fontFamily: 'Inter, sans-serif' }}>{t.name}</div>
                      <div className="text-xs" style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.25)' }}>{t.role}</div>
                    </div>
                  </div>
                  <span
                    className="text-xs flex-shrink-0 ml-2 px-2.5 py-1 rounded-full"
                    style={{ fontFamily: 'Inter, sans-serif', color: '#5DC48E', backgroundColor: 'rgba(93,196,142,0.1)' }}
                  >{t.result}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-3">
          {[
            { value: '500+', label: 'Kunden aus Pinneberg & Umgebung' },
            { value: '20 Min.', label: 'reichen wirklich aus' },
            { value: '1 : 1', label: 'Betreuung jederzeit' },
            { value: '5,0 ★', label: 'auf Google' },
          ].map((stat, i) => (
            <div
              key={i}
              className="text-center py-7 rounded-2xl border"
              style={{ borderColor: 'rgba(93,196,142,0.1)' }}
            >
              <div
                className="text-2xl md:text-3xl font-bold text-white"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                {stat.value}
              </div>
              <div
                className="text-xs mt-2 leading-snug px-2"
                style={{ fontFamily: 'Inter, sans-serif', color: 'rgba(255,255,255,0.28)' }}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
